import { render } from "./Navgater.vue?vue&type=template&id=6444656e&scoped=true&ts=true"
import script from "./Navgater.vue?vue&type=script&lang=ts"
export * from "./Navgater.vue?vue&type=script&lang=ts"

import "./Navgater.vue?vue&type=style&index=0&id=6444656e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6444656e"]])

export default __exports__